import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from './services/auth/auth.service';
import { GlobalService } from 'src/app/services/shared/global.service';
import { NotificationService } from 'src/app/services/push-notifications/notification.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy{
  public isLoggedIn: boolean=false;
  public globalErrorMessage!: string;
  public globalSuccessMessage!: string;
  public globalwarningMessage!: string;
  showSuccessAlert: boolean = false;

  modalData: { title: string; body: string; txnId?: string; txnType: string; createdAt: Date|null } | null = null;
  private modalSub!: Subscription;

  constructor(
    private authService: AuthService,
    private globalService: GlobalService,
    private notificationService: NotificationService,
    private route: ActivatedRoute
    ) {
      //Show global success message
      this.globalService.globalSuccessMessageUpdated.subscribe(() => {
        this.globalSuccessMessage = this.globalService.getGlobalSuccessMessage();
        this.showSuccessAlert=true;
        setTimeout(() => {
          this.showSuccessAlert=false;
        }, 5000); // Hide the alert after 5 seconds
      });

      //Show global error message
      this.globalService.globalErrorMessageUpdated.subscribe(() => {
        this.globalErrorMessage = this.globalService.getGlobalErrorMessage();
      });

      //Show global warning message
      this.globalService.globalWarningMessageUpdated.subscribe(() => {
        this.globalwarningMessage = this.globalService.getGlobalWarningMessage();
      });
  }

  ngOnInit() {
    this.isLoggedIn = this.authService.isLoggedIn;

    if(this.isLoggedIn){
      // Ask for browser push permissions and send token to backend
      this.notificationService.requestPermission();

      // Start listening for incoming notifications while the app is active
      this.notificationService.listenForMessages();
    }

     // 1. Subscribe to the foreground click events broadcast by the notification service
    this.modalSub = this.notificationService.modalTrigger$.subscribe((data) => {
      this.modalData = data;

      // Force jQuery to open the Bootstrap 4 modal element markup structure
      $('#globalNotificationModal').modal('show');
    });

    // 2. Handle background system notifications clicks (via URL parameters)
    this.route.queryParams.subscribe(params => {
      if (params['openModal'] === 'true' && params['txnId']) {
        this.notificationService.triggerGlobalModal({
          title: 'Notification Alert',
          body: 'Opening item context details...',
          txnId: params['txnId'],
          txnType: params['txnType'],
          createdAt: null
        });
      }
    });
  }

  ngOnDestroy() {
    if (this.modalSub) {
      this.modalSub.unsubscribe(); // Clean up memory leaks
    }
  }
}
